import { ReactComponent as RegionPin } from '../assets/pin.svg'

export const Pin = () => (
    <RegionPin height="40" width="106" />
)
